import styled from '@emotion/styled';

export const PaddedDiv = styled.div`
  padding: 0 1.25rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    padding: 0 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 2.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 3.5rem;
  }
`;
